export default __webpack_public_path__ + "static/outline-f3ce99b2340cb3996239a57fb7e2d81f.png";